module.exports = __webpack_public_path__ + "static/sport/swiper-3.35d7d75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport4/swiper-3.png
// module id = XMi7
// module chunks = 0